export default {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#phone",
      toString: function () {
        return this.url;
      }
    }